import { EditFilled } from "@ant-design/icons";
import { Color } from "@types";
import styled from "styled-components";

export const CustomEditIcon = styled(EditFilled)({
  color: Color.PrimaryBase,
});